define(['jQuery', 'underscore', 'library/fcse-util/url', 'TravelsearchMetadata'],
    function ($, _, Url, TravelsearchMetadata) {

        /**
         * Custom converters for scope => query transformation
         */
        var customConvertersToQuery = {
            bool: function (value) {
                //backend expects int here
                return value ? 1 : 0;
            }
        };

        /**
         * Custom converters for query => scope transformation
         */
        var customConvertersFromQuery = {
            int: function (value) {
                return parseInt(value, 10);
            },
            float: function (value) {
                return parseFloat(value);
            },
            bool: function (value) {
                return "true" == value || value > 0;
            }
        };

        var ParamConverter = { };

        ParamConverter.convertParamToQuery = function (name, value, url) {
            var nameWithoutPrefix = name.replace(/.+\./, "");
            if (nameWithoutPrefix in TravelsearchMetadata) {
                var convert = function (value) {
                    return value.toString();
                };
                if (TravelsearchMetadata[nameWithoutPrefix].type in customConvertersToQuery) {
                    convert = customConvertersToQuery[TravelsearchMetadata[nameWithoutPrefix].type];
                }
                if (TravelsearchMetadata[nameWithoutPrefix].array) {
                    if (!$.isArray(value)) {
                        throw new Error("Parameter " + name + " is supposed to be an array but it's not.");
                    }
                    if (value.length) {
                        url[name] = _.map(value, convert).join(";");
                    } else {
                        delete url[name];
                    }
                } else {
                    url[name] = convert(value);
                }
            } else if ($.isArray(value)) {
                url[name] = value.join(";");
            } else {
                url[name] = value;
            }
        };

        ParamConverter.convertParamFromQuery = function (name, value, params) {
            var nameWithoutPrefix = name.replace(/.+\./, "");
            if (nameWithoutPrefix in TravelsearchMetadata) {
                var convert = function (value) {
                    return value;
                };
                if (TravelsearchMetadata[nameWithoutPrefix].type in customConvertersFromQuery) {
                    convert = customConvertersFromQuery[TravelsearchMetadata[nameWithoutPrefix].type];
                }
                if (TravelsearchMetadata[nameWithoutPrefix].array) {
                    params[name] = _.map(value.split(";"), convert);
                } else {
                    params[name] = convert(value);
                }
            } else {
                //unknown custom parameter not in Travelsearch
                params[name] = value;
            }
        };

        ParamConverter.convertParams = function (params, url) {
            var queryKeys = _.keys(url.query);
            var common = _.intersection(_.keys(params), queryKeys);
            // cleanup params which are already in url.query but not in scope.params.
            _.each(_.difference(queryKeys, common), function (key) {
                url.query[key] = null;
            });

            for (var param in params) {
                if (params.hasOwnProperty(param)) {
                    ParamConverter.convertParamToQuery(param, params[param], url.query);
                }
            }
            // temporary cleanup to avoid empty params from going to query.
            _.each(url.query, function (value, key, obj) {
                if ((_.isObject(value) || _.isString(value) ||
                    value === null || value === undefined) &&
                    _.isEmpty(value)) {
                    // Do not delete primitive type values (underscore counts
                    // them as empty objects) -- AG.
                    delete obj[key];
                }
            });
        };

        ParamConverter.convertQuery = function (query, params) {
            for (var param in query) {
                if (query.hasOwnProperty(param)) {
                    ParamConverter.convertParamFromQuery(param, query[param], params);
                }
            }
        };

        ParamConverter.toQuery = function (params) {
            var url = new Url();
            ParamConverter.convertParams(params, url);
            return url.query;
        };

        ParamConverter.fromQuery = function (url) {
            var query = {},
                hash = {};
            ParamConverter.convertQuery(url.query, query);
            ParamConverter.convertQuery(url.hash, hash);
            //hash takes preference
            var merged = _.extend({}, query, hash);
            return {
                query: query,
                hash: hash,
                merged: merged
            }
        };

        return ParamConverter;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-util/paramConverter.js
// module id = 69
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 23